import React from "react";
import { Tabs, Row, Col, Image, Typography, Card } from "antd";

const { Text } = Typography;
const { TabPane } = Tabs;

const OfferList = ({ data }) => {
    return (
            <Tabs
                defaultActiveKey={data?.offers[0]?.offer_name}
                tabPosition="top"
                style={{ marginTop: 12 }}
            >
                {data?.offers?.map((category) => (
                    <TabPane
                        tab={category.offer_name}
                        key={category.offer_name}
                    >
                        {category.list.map((offer) => (
                            <Row
                                key={offer.id}
                                gutter={[16]}
                                style={{
                                    padding: "12px 8px",
                                    borderBottom: "1px solid #f0f0f0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Col span={4}>
                                    <Image
                                        src={offer.image_url}
                                        alt="Offer Icon"
                                        preview={false}
                                        style={{ maxWidth: "80px" }}
                                    />
                                </Col>

                                <Col span={20}>
                                    <Text>{offer.short_description}</Text>
                                    <br />
                                    <Text strong>Valid Till: </Text>
                                    <Text>{offer.duration}</Text>
                                </Col>
                            </Row>
                        ))}
                    </TabPane>
                ))}
            </Tabs>
    );
};

export default OfferList;
